module.exports = __webpack_public_path__ + "static/media/logo.cc26da24.webp";